module.exports = __webpack_public_path__ + "fonts/noto-sans-kr-54-300-normal.3a48db6.woff2";